export default "https://cdn-static.gokick.com/assets/ea2c661fec3366c14365f7d1c68d2a3d0c715dc9/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";